import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  CardContent,
  CardActions,
  Button,
  Typography,
  Grid,
  Paper,
  useMediaQuery,
  Dialog,
  DialogTitle,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import { UserType } from "../../utils/constants";
import { getLocationFullName, isTrack } from "../../utils/locationUtils";
import { getUnitName } from "../../utils/loadTypeUtils";

const useStyles = makeStyles((theme) => ({
  inventoryCardAvatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  listHeader: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(2),
  },
  cardItemLeft: {
    display: "flex",
    justifyContent: "flex-end",
    fontWeight: 500,
  },
  cardItemRight: {
    display: "flex",
    marginTop: theme.spacing(1),
  },
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
  searchContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const InventoryCard = ({ itm: inventory, match }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  if (!inventory) return <></>;

  const getFullName = (productName, size = 26) => {
    if (!productName) return "";
    if (!isSmall) return productName;
    if (productName.length <= size) return productName;
    return productName.substring(0, size - 3) + "...";
  };

  return (
    <Grid item xs={12} md={3} lg={4} variant="outlined" key={inventory.id}>
      <Paper variant="outlined" elevation={0} className={classes.card}>
        <CardContent>
          {window.appUser.type === UserType.CREW ? (
            <Typography color="textSecondary" variant="h6" gutterBottom>
              {inventory.productName}
            </Typography>
          ) : (
            <Typography variant="h6" color="secondary" gutterBottom>
              <Link
                className={classes.link}
                to={"/inventories/" + inventory.id}
              >
                {inventory.productName}
              </Link>
            </Typography>
          )}
          <Typography variant="body2">
            Product Code: {inventory.productCode}
          </Typography>
          <Typography variant="body2">
            Account Name: {getFullName(inventory.accountName)}
          </Typography>
          <Typography variant="body2">
            Lot Number: {inventory.lotNumber}
          </Typography>
          <Typography variant="body2">
            Quantity Onnand: {inventory.quantityOnHand}
          </Typography>
          <Typography variant="body2">
            Date Received:{" "}
            {format(new Date(inventory.receivedAt), "MM/dd/yyyy")}
          </Typography>
        </CardContent>
        {match && (
          <CardActions className={classes.actions}>
            <Button onClick={() => setOpen(true)}>Locations</Button>
            <Link
              className={classes.link}
              to={"/search/timeline/" + inventory.id}
            >
              <Button>Timeline</Button>
            </Link>
          </CardActions>
        )}
      </Paper>
      <Dialog
        open={open}
        scroll={"paper"}
        fullWidth
        fullScreen={isSmall ? true : false}
      >
        <DialogTitle>Locations</DialogTitle>
        <DialogContent dividers>
          {
            <Paper variant="outlined">
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{isSmall ? "Loc" : "Location"}</TableCell>
                      <TableCell>
                        {isSmall ? "Onhd" : "Quantity Onhand"}
                      </TableCell>
                      <TableCell>
                        {isSmall ? "Cmtd" : "Quantity Committed"}
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {inventory.inventoryItems.items.map((itm) => (
                      <TableRow key={itm.id}>
                        <TableCell>
                          {getLocationFullName(itm.location)}
                        </TableCell>
                        <TableCell>{`${itm.quantityOnHand} ${
                          isSmall ? "" : getUnitName(inventory.inventoryUOM)
                        }`}</TableCell>
                        <TableCell>{`${
                          itm.quantityCommitted ? itm.quantityCommitted : 0
                        } ${
                          isSmall ? "" : getUnitName(inventory.inventoryUOM)
                        }`}</TableCell>
                        <TableCell>
                          <Link
                            className={classes.link}
                            to={
                              isTrack(itm.areaId)
                                ? "/trackManagement"
                                : "/search/relocate/" + itm.id
                            }
                          >
                            <Button size={isSmall ? "small" : ""}>
                              Relocate
                            </Button>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default InventoryCard;
